export default __webpack_public_path__ + "static/media/employment-support.15956099.svg";